import { create } from 'zustand';
import { DialerCallPulseStates, DialerCallPulseStoreType } from '../types/store/dialer-call-pulse.types';

const defaultValues: DialerCallPulseStates = {
  isSubscriptionConnected: false,
  recordingTimestamps: [],
  isRecording: false,
  isOnHold: false,
  callStatus: null,
  transferredTo: '',
  autoRecording: null,
  callTransferEligible: null,
};

// recording and transferring subscription data
export const useDialerCallPulseStore = create<DialerCallPulseStoreType>((set) => ({
  ...defaultValues,
  setIsSubscriptionConnected: (isSubscriptionConnected) => set({ isSubscriptionConnected }),
  appendRecordingTimestamp: (recordingTimestamp) =>
    set((state) => ({ ...state, recordingTimestamps: [...state.recordingTimestamps, recordingTimestamp] })),
  validLastRecordingTimestamp: () =>
    set((state) => {
      const updatedRecordingTimestamps = state.recordingTimestamps.slice(0, state.recordingTimestamps.length - 1);
      updatedRecordingTimestamps.push({
        ...state.recordingTimestamps[state.recordingTimestamps.length - 1],
        isSuccess: true,
      });
      return {
        ...state,
        recordingTimestamps: updatedRecordingTimestamps,
      };
    }),
  removeLastRecordingTimestamp: () =>
    set((state) => ({
      ...state,
      recordingTimestamps: state.recordingTimestamps.filter((stamp) => stamp.isSuccess),
    })),
  setIsRecording: (isRecording) => set({ isRecording }),
  setIsOnHold: (isOnHold) => set({ isOnHold }),
  resetDialerCallPulse: () =>
    set((state) => ({
      ...defaultValues,
      callTransferEligible: state.callTransferEligible,
      autoRecording: state.autoRecording,
    })),
  updateCallStatus: (callStatus) => set({ callStatus }),
  resetCallStatus: () => set({ callStatus: null }),
  setTransferredTo: (transferredTo) => set({ transferredTo }),
  setAutoRecording: (autoRecording) => set({ autoRecording }),
  setCallTransferEligible: (callTransferEligible) => set({ callTransferEligible }),
}));
